import { snackbar } from "@/core/controller/snackbar_controller";
import { getAccountName } from "@/core/domain/model/jwtAuthToken";
import { headers } from "../const/headers";
import Account, { accountDefault } from "../domain/account/account";

class AccountController {
  context = null;
  headers = headers
  userName = null
  loading = false
  search = ""
  searchClient = ""
  searchClientInModal = ""
  searchTechnicianInModal = ""
  searchVehicle = ""
  searchEquipment = ""
  searchTechnician = ""
  technicianIDToInclude = null 
  clientIDToInclude = null
  equipmentIDsToInclude = null
  vehicleIDsToInclude = null
  dialog = false
  vehiclesAndEquipDialog = false
  form = accountDefault({})
  formEquipVehicle = {}
  equipmentSelected = []
  vehicleSelected = []
  statusPaginated = 1
  statusSelected = 1
  statusList = [
    { text: "Todos", value: 0 },
    { text: "Ativo", value: 1 },
    { text: "Inativo", value: 2 },
  ]
  emailRules = value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || 'E-mail inválido.'
  }

  selectedVehicles = []
  selectedEquipments = []

  vehicleHeaders = [
    {
      text: 'Placa',
      align: 'start',
      sortable: true,
      value: 'plate',
    }
  ]

  equipmentHeaders = [
    {
      text: 'Serial',
      align: 'start',
      sortable: true,
      value: 'name',
    },
  ]

  userGroup = [
    { id: 1, name: "Administrador" },
    { id: 2, name: "Cliente administrador" },
    { id: 3, name: "Cliente visualizador" },
    { id: 6, name: "Cliente Produção" },
    { id: 4, name: "Técnico" },
    { id: 5, name: "Produção" },
    { id: 7, name: "Técnico Visualizador"}
  ];

  accountPagination = {
    total: 0,
    items: []
  }

  options = {
    page: 1,
    itemsPerPage: 40,
    groupBy: [],
    sortBy: ["name"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  clientPagination = {
    total: 0,
    items: []
  }

  clientOptions = {
    page: 1,
    itemsPerPage: 100,
    groupBy: [],
    sortBy: ["id"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  vehiclePagination = {
    total: 0,
    items: []
  }

  vehicleOptions = {
    page: 1,
    itemsPerPage: 40,
    groupBy: [],
    sortBy: ["id"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  equipmentPagination = {
    total: 0,
    items: []
  }

  equipmentOptions = {
    page: 1,
    itemsPerPage: 40,
    groupBy: [],
    sortBy: ["name"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  technicianPagination = {
    total: 0,
    items: []
  }

  technicianOptions = {
    page: 1,
    itemsPerPage: 40,
    groupBy: [],
    sortBy: ["name"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  constructor(
    context,
    fetchAccountUseCaseImpl,
    createAccountUseCaseImpl,
    changeAccountUseCaseImpl,
    deleteAccountUseCaseImpl,
    fetchClientUseCaseImpl,
    fetchVehicleUseCaseImpl,
    fetchEquipmentUseCaseImpl,
    fetchTechnicianUseCaseImpl,
    refreshUseCaseImpl,
    getVisibleEquipmentsByAccountIDUsecaseImpl,
    getVisibleVehiclesByAccountIDUsecaseImpl
  ) {
    this.context = context;
    this.fetchAccountUseCaseImpl = fetchAccountUseCaseImpl
    this.createAccountUseCaseImpl = createAccountUseCaseImpl
    this.changeAccountUseCaseImpl = changeAccountUseCaseImpl
    this.deleteAccountUseCaseImpl = deleteAccountUseCaseImpl
    this.fetchClientUseCaseImpl = fetchClientUseCaseImpl
    this.fetchVehicleUseCaseImpl = fetchVehicleUseCaseImpl
    this.fetchEquipmentUseCaseImpl = fetchEquipmentUseCaseImpl
    this.fetchTechnicianUseCaseImpl = fetchTechnicianUseCaseImpl
    this.refreshUseCaseImpl = refreshUseCaseImpl
    this.getVisibleEquipmentsByAccountIDUsecaseImpl = getVisibleEquipmentsByAccountIDUsecaseImpl
    this.getVisibleVehiclesByAccountIDUsecaseImpl = getVisibleVehiclesByAccountIDUsecaseImpl
  }

  mounted() {
    this.userName = getAccountName()
  }

  async paginate() {
    this.loading = true
    try {
      this.accountPagination = await this.fetchAccountUseCaseImpl(this.options, this.search, this.statusSelected)
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false
    }
  }

  async technicianPaginate() {
    try {
      this.technicianPagination = await this.fetchTechnicianUseCaseImpl(this.technicianOptions, this.searchTechnician || this.searchTechnicianInModal, this.statusPaginated, this.technicianIDToInclude)
    } catch (error) {
      console.log(error);
    }
  }

  async clientPaginate() {
    try {
      this.clientPagination = await this.fetchClientUseCaseImpl(this.clientOptions, this.searchClient || this.searchClientInModal, this.statusPaginated, this.clientIDToInclude)
    } catch (error) {
      console.log(error);
    }
  }

  async equipmentPaginate() {
    this.equipmentTableLoading = true
    try {
      this.equipmentPagination = await this.fetchEquipmentUseCaseImpl(this.equipmentOptions, this.searchEquipment, this.statusPaginated, this.equipmentIDsToInclude)
    } catch (error) {
      console.log(error);
    } finally {
      this.equipmentTableLoading = false
    }
  }

  async vehiclePaginate() {
    this.vehicleTableLoading = true
    try {
      this.vehiclePagination = await this.fetchVehicleUseCaseImpl(this.vehicleOptions, this.searchVehicle, this.statusPaginated, null, this.vehicleIDsToInclude)
    } catch (error) {
      console.log(error);
    } finally {
      this.vehicleTableLoading = false
    }
  }


  async open() {
    this.dialog = true
    this.form = accountDefault({})
    this.searchClientInModal = ""
    this.clientIDToInclude = null

    await this.clientPaginate()
  }

  close() {
    this.context.$refs.crud.resetValidation()
    this.dialog = false

    this.form = accountDefault({})
    this.searchClientInModal = ""
    this.clientIDToInclude = null
  }

  async create() {
    if (this.context.$refs.crud.validate()) {
      try {
        this.loading = true
        if (this.form.id != 0) {
          await this.changeAccountUseCaseImpl(this.form.id, this.form)
          snackbar.show({ message: "Alterado com sucesso!!!", color: "#008000", timeout: 3000 })
        } else {
          await this.createAccountUseCaseImpl(this.form)
          snackbar.show({ message: "Adicionado com sucesso!!!", color: "#008000", timeout: 3000 })
        }
      } catch (error) {
        snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 3000 })
      } finally {
        this.paginate()
        this.loading = false
        this.close();
      }
    }
  }

  async change(item) {
    this.dialog = true
    this.form = new Account({ ...item })
    this.searchClientInModal = item.clientName
    this.clientIDToInclude = item.clientID
    this.clientPagination.items = [{ id: item.clientID, name: item.clientName }]

    this.searchTechnicianInModal = item.technicianName
    this.technicianIDToInclude = item.technicianID
    this.technicianPagination.items = [{ id: item.technicianID, name: item.technicianName }]

    await this.clientPaginate();
    await this.technicianPaginate();
  }

  async delete(item) {
    try {
      const confirm = await snackbar.confirm({ message: "Deseja realmente excluir o registro?", color: "primary", timeout: 5000 })
      if (confirm) {
        await this.deleteAccountUseCaseImpl(item.id)
        this.paginate()
        snackbar.show({ message: "Resgistro excluído com sucesso!", color: "#008000", timeout: 1000 })
      }
    } catch (error) {
      snackbar.show({ message: error.toString() })
    }
  }


  watchOptions() {
    this.paginate()
  }
  watchSearch() {
    this.paginate()
  }
  watchClientOptions() {
    this.clientPaginate()
  }
  watchClientSearch() {
    this.clientPaginate()
  }
  watchClientSearchInModal() {
    this.clientPaginate()
  }
  watchTechnicianOptions() {
    this.technicianPaginate()
  }
  watchTechnicianSearch() {
    this.technicianPaginate()
  }
  watchTechnicianSearchInModal() {
    this.technicianPaginate()
  }
  watchVehicleOptions() {
    this.vehiclePaginate()
  }
  watchVehicleSearch() {
    this.vehiclePaginate()
  }
  watchEquipmentOptions() {
    this.equipmentPaginate()
  }
  watchEquipmentSearch() {
    this.equipmentPaginate()
  }

  changeStatus() {
    this.paginate()
  }

  async changeVehicleEquipment(item) {
    const linkedEquipments = await this.getVisibleEquipmentsByAccountIDUsecaseImpl(item.id)
    const linkedVehicles = await this.getVisibleVehiclesByAccountIDUsecaseImpl(item.id)
    
    this.equipmentSelected = linkedEquipments
    this.vehicleSelected = linkedVehicles
    
    this.equipmentIDsToInclude = linkedEquipments.length > 0 
      ? linkedEquipments.map(e => e.id).join(',') 
      : null
    
    this.vehicleIDsToInclude = linkedVehicles.length > 0 
      ? linkedVehicles.map(v => v.id).join(',') 
      : null
    
    this.form = { ...item }
    
    await Promise.all([
      this.equipmentPaginate(),
      this.vehiclePaginate()
    ])
    
    this.vehiclesAndEquipDialog = true
  }

  closeVehicleEquipmentDialog() {
    this.vehiclesAndEquipDialog = false
    this.equipmentIDsToInclude = null
    this.vehicleIDsToInclude = null
    this.equipmentSelected = []
    this.vehicleSelected = []
  }

  isSelectedEquipment(item) {
    return this.equipmentSelected.some((el) => el.id === item.id);
  }
  toggleItemEquipment(item) {
    if (this.equipmentSelected.some((el) => el.id === item.id)) {
      this.removeItemEquipment(item);
    } else {
      this.equipmentSelected.push(item);
    }
  }
  removeItemEquipment(item) {
    if (this.equipmentSelected.some((el) => el.id == item.id)) {
      let index = this.equipmentSelected.map((e) => e.id).indexOf(item.id);
      if (index > -1) {
        this.equipmentSelected.splice(index, 1);
      }
    }
  }

  isSelectedVehicle(item) {
    return this.vehicleSelected.some((el) => el.id === item.id);
  }
  toggleItemVehicle(item) {
    if (this.vehicleSelected.some((el) => el.id === item.id)) {
      this.removeItemVehicle(item);
    } else {
      this.vehicleSelected.push(item);
    }
  }
  removeItemVehicle(item) {
    if (this.vehicleSelected.some((el) => el.id == item.id)) {
      let index = this.vehicleSelected.map((e) => e.id).indexOf(item.id);
      if (index > -1) {
        this.vehicleSelected.splice(index, 1);
      }
    }
  }

  async saveVehicleEquipmentVisibility() {
    this.form.visibleVehicle = this.vehicleSelected.length > 0 
      ? this.vehicleSelected.map((vehicle) => vehicle.id).join(",") 
      : null
    this.form.visibleEquipment = this.equipmentSelected.length > 0 
      ? this.equipmentSelected.map((equipment) => equipment.id).join(",") 
      : null
    
    try {
      await this.changeAccountUseCaseImpl(this.form.id, this.form)
      await this.refreshUseCaseImpl()
      snackbar.show({ message: "Alterado com sucesso!", color: "#008000", timeout: 3000 })
    } catch (error) {
      snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 3000 })
    } finally {
      this.closeVehicleEquipmentDialog()
    }
  }


  async checkboxChange(item) {
    if (!item || item.id === undefined || item.active === undefined) {
      console.error('Item inválido:', item);
      return;
    }
    try {
      this.form = { ...item }
      this.form.active = item.active
      const res = await this.changeAccountUseCaseImpl(this.form.id, this.form)
      
      if(res){
        snackbar.show({ message: "Status alterado com sucesso!", color: "#008000", timeout: 3000 })
        this.paginate()
      }
    } catch (error) {
      snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 3000 })
    }
  }
}

export default AccountController